// #/services/workspaces/getWorkspace.ts
import superjson from 'superjson';

import { AWS_S3_BUCKET } from '#/config/constants';
import { s3 } from '#/services/s3';

function parseS3ObjectBodyJson<T = Record<string, any>>(args: {
  s3Object: any;
}) {
  const { s3Object } = args;

  // console.debug('parseS3ObjectDataJson(', JSON.stringify(args), ')');

  if (!s3Object?.Body) {
    return {} as T;
  }

  const json = superjson.parse<T>(
    typeof s3Object?.Body !== 'string'
      ? s3Object?.Body?.toString()
      : s3Object?.Body,
  );
  // console.debug('[parseS3ObjectDataJson]', { json });

  return json;
}

async function getS3Object(getObjectParams) {
  try {
    try {
      return await s3.getObject(getObjectParams).promise();
    } catch (error: any) {
      if (error.code === 'NoSuchKey') {
        return null;
      }
    }
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error getting S3 object: ${error.message}`);
  }
}

export async function readJsonFile<T = Record<string, any>>(args: {
  s3ObjectKey: string;
}): Promise<T | null> {
  try {
    const { s3ObjectKey } = args;

    // console.info('readJsonFile(', JSON.stringify(args), ')');

    const s3Object = await getS3Object({
      Bucket: AWS_S3_BUCKET,
      Key: s3ObjectKey,
    });

    if (s3Object == null) {
      return null;
    }

    return parseS3ObjectBodyJson<T>({ s3Object });
  } catch (error: any) {
    console.error(error);
    throw new Error(`Error reading JSON file: ${error.message}`);
  }
}
export default readJsonFile;
